import React from "react";

const TableProgress = function ({
    value,
    color
}) {
    const percent = (value * 100).toFixed(2);
    return (
        <div style={{ width: "100%" }}>
            <div
                className="d-flex align-items-center"
                style={{
                    width: "calc(100% - 15mm)"
                }}
            >
                <div style={{
                    width: `${percent}%`,
                    backgroundColor: color,
                    height: "10px",
                    borderRadius: "10px"
                }}
                />
                <span className="custom--progress-text" style={{ color }} percent={`${percent}%`} />
            </div>
        </div>
    );
};

export default TableProgress;
